<template>
  <div class="agree-more">
    <section class="top-fixing">
      <section class="common-sub-top container">
        <section class="top-info-wrap">
          <div class="prev-wrap">
            <span class="name-wrap"> <span class="name" @click="pageBefore()">닫기</span></span>
          </div>
        </section>
      </section>
    </section>
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <div id="hidden">
      <b><font color="red" size="3">vuex 변수 정보</font></b>
    </div>
    <table border="1" class="debug-table">
      <thead>
        <colgroup>
          <col width="20%" />
          <col width="80%" />
        </colgroup>
      </thead>
      <tbody>
        <tr>
          <th>배포타입 [0:배포 1:개발]</th>
          <td>{{ this.$store.state.serverType }}</td>
        </tr>
        <tr>
          <th>개발 도메인</th>
          <td>{{ this.$store.state.apiDomain }}</td>
        </tr>
        <tr>
          <th>문진표 도메인</th>
          <td>{{ this.$store.state.checkupIp }}</td>
        </tr>
        <tr>
          <th>userId</th>
          <td>{{ this.$store.state.storeUserId }}</td>
        </tr>
        <tr>
          <th>hospNo</th>
          <td>{{ this.$store.state.storeHospNo }}</td>
        </tr>
        <tr>
          <th>mac</th>
          <td>
            <div style="display: flex">
              <div>
                {{ this.$store.state.storeMac }}
              </div>
              <div style="padding-left: 20px">
                <button @click="copyJson()"><font color="red">Copy</font></button>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <th>procType</th>
          <td>{{ this.$store.state.storeProcType }}</td>
        </tr>
        <tr>
          <th>doctNm</th>
          <td>{{ this.$store.state.storeDoctNm }}</td>
        </tr>
        <tr>
          <th>doctNm</th>
          <td>{{ this.$store.state.storeDoctNm }}</td>
        </tr>
        <tr>
          <th>hospNm</th>
          <td>{{ this.$store.state.storeHospNm }}</td>
        </tr>
        <tr>
          <th>login</th>
          <td>{{ this.$store.state.storeLogin }}</td>
        </tr>
        <tr>
          <th>admYn</th>
          <td>{{ this.$store.state.storeAdmYn }}</td>
        </tr>
        <tr>
          <th>web version</th>
          <td>{{ this.$store.state.storeWebVersion }}</td>
        </tr>
      </tbody>
    </table>

    <b><font color="red" size="3">device 변수 정보</font></b>
    <table border="1" class="debug-table">
      <thead>
        <colgroup>
          <col width="20%" />
          <col width="80%" />
        </colgroup>
      </thead>
      <tbody>
        <tr>
          <th>deviceId</th>
          <td>{{ this.$store.state.deviceInfo.deviceId }}</td>
        </tr>
        <tr>
          <th>version</th>
          <td>{{ this.$store.state.deviceInfo.version }}</td>
        </tr>
        <tr>
          <th>ip</th>
          <td>{{ this.$store.state.deviceInfo.ip }}</td>
        </tr>
        <tr>
          <th>port</th>
          <td>{{ this.$store.state.deviceInfo.port }}</td>
        </tr>
        <tr>
          <th>model</th>
          <td>{{ this.$store.state.deviceInfo.model }}</td>
        </tr>
        <tr>
          <th>osType</th>
          <td>{{ this.$store.state.deviceInfo.osType }}</td>
        </tr>
        <tr>
          <th>osVersion</th>
          <td>{{ this.$store.state.deviceInfo.osVersion }}</td>
        </tr>
      </tbody>
    </table>

    <b><font color="red" size="3">설정 변수 정보</font></b>
    <table border="1" class="debug-table">
      <thead>
        <colgroup>
          <col width="20%" />
          <col width="80%" />
        </colgroup>
      </thead>
      <tbody>
        <tr>
          <th>라이선스 타입</th>
          <td>{{ this.$store.state.settingInfo.licenseType }}</td>
        </tr>
        <tr>
          <th>[문진] 병원 문진</th>
          <td>{{ this.$store.state.settingInfo.chkHosp }}</td>
        </tr>
        <tr>
          <th>[문진] 국가검진</th>
          <td>{{ this.$store.state.settingInfo.chkNat }}</td>
        </tr>
        <tr>
          <th>[문진] 정신과 문진</th>
          <td>{{ this.$store.state.settingInfo.chkPsy }}</td>
        </tr>
        <tr>
          <th>[문진] 영유아 문진</th>
          <td>{{ this.$store.state.settingInfo.chkChild }}</td>
        </tr>
        <tr>
          <th>환자메모표시</th>
          <td>{{ this.$store.state.settingInfo.memoViewYn }}</td>
        </tr>
        <tr>
          <th>환자특이사항표시</th>
          <td>{{ this.$store.state.settingInfo.opdMemoViewYn }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  methods: {
    pageBefore() {
      this.$router.push({
        name: '설정'
      });
    },
    copyJson() {
      let text = JSON.stringify(this.$store.state.storeMac);
      const doc = document.createElement('textarea');
      doc.value = text;
      document.querySelector('#hidden').appendChild(doc);
      doc.focus();
      doc.select();
      document.execCommand('copy');
      document.querySelector('#hidden').removeChild(doc);
    }
  }
};
</script>

<style scoped>
.debug-wrap {
  padding: 10px;
}
h1 {
  margin: 10px;
  color: #ff6357;
}
.debug-table {
  width: 100%;
  margin-bottom: 1.5em;
  font-size: 14px;
  color: #777;
  border-collapse: collapse;
}

.debug-table thead tr th {
  border: 1px solid #c0c0c0;
}

.debug-table tr th {
  background: #e6e6e6;
}

.debug-table tr {
  border: 1px solid #c0c0c0;
}

.debug-table tr td {
  border: 1px solid #c0c0c0;
}

.debug-table th,
.debug-table td {
  padding: 0.4rem;
  padding-left: 10px;
  word-break: break-word;
}

.copy-success {
  visibility: hidden;
  opacity: 0;
  position: fixed;
  left: 50%;
  bottom: 3em;
  transform: translateX(-50%);
  padding: 10px 20px;
  color: #fff;
  background-color: #000;
  border-radius: 50px;
  transition: all 0.5s;
}
.copy-success.view {
  visibility: visible;
  opacity: 1;
}
</style>
